var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/card/card.tsx";
const _excluded = ["children", "variant", "size", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Text } from 'soapbox/components/ui';
import SvgIcon from 'soapbox/components/ui/icon/svg-icon';
const sizes = {
  md: 'p-4 sm:rounded-xl',
  lg: 'p-4 sm:p-6 sm:rounded-xl',
  xl: 'p-4 sm:p-10 sm:rounded-3xl'
};
const messages = defineMessages({
  back: {
    "id": "card.back.label",
    "defaultMessage": "Back"
  }
});
/** An opaque backdrop to hold a collection of related elements. */
const Card = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      variant,
      size = 'md',
      className
    } = _ref,
    filteredProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, filteredProps, {
    className: classNames({
      'space-y-4': true,
      'bg-white dark:bg-slate-800 text-black dark:text-white shadow-lg dark:shadow-inset overflow-hidden': variant === 'rounded',
      [sizes[size]]: variant === 'rounded'
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 3
    }
  }), children);
});
/**
 * Card header container with back button.
 * Typically holds a CardTitle.
 */
const CardHeader = ({
  children,
  backHref,
  onBackClick,
  className
}) => {
  const intl = useIntl();
  const renderBackButton = () => {
    if (!backHref && !onBackClick) {
      return null;
    }
    const Comp = backHref ? Link : 'button';
    const backAttributes = backHref ? {
      to: backHref
    } : {
      onClick: onBackClick
    };
    return /*#__PURE__*/React.createElement(Comp, _extends({}, backAttributes, {
      className: "mr-2 text-gray-900 dark:text-gray-100 focus:ring-primary-500 focus:ring-2",
      "aria-label": intl.formatMessage(messages.back),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(SvgIcon, {
      src: require('@tabler/icons/arrow-left.svg'),
      className: "h-6 w-6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 9
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "sr-only",
      "data-testid": "back-button",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 9
      }
    }, intl.formatMessage(messages.back)));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `mb-4 flex flex-row items-center ${className}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 5
    }
  }, renderBackButton(), children);
};
/** A card's title. */
const CardTitle = ({
  title
}) => /*#__PURE__*/React.createElement(Text, {
  className: "grow",
  size: "xl",
  weight: "bold",
  tag: "h1",
  "data-testid": "card-title",
  truncate: true,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 89,
    columnNumber: 3
  }
}, title);

/** A card's body. */
const CardBody = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  "data-testid": "card-body",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 94,
    columnNumber: 3
  }
}, children);
export { Card, CardHeader, CardTitle, CardBody };